import { render, staticRenderFns } from "./AlteracaoCampanhaWhatsapp.vue?vue&type=template&id=54236bbd"
import script from "./AlteracaoCampanhaWhatsapp.vue?vue&type=script&lang=js"
export * from "./AlteracaoCampanhaWhatsapp.vue?vue&type=script&lang=js"
import style0 from "./AlteracaoCampanhaWhatsapp.vue?vue&type=style&index=0&id=54236bbd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports